export function getCNVSummary(items) {
    const list = Array.isArray(items) ? items : [];
    const full = list.filter(s => s && s["Annotation_mode"] === "full").length;
    const split = list.filter(s => s && s["Annotation_mode"] === "split").length;
    const tot = list.length;
    return {
        full_tot: full,
        split_tot: split,
        tot
    };
}